/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetRestrictionSnapshotsRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_restriction_snapshots.pb'
import {GetRestrictionSnapshotsResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_restriction_snapshots.pb'


export const getRestrictionSnapshots = (request: GetRestrictionSnapshotsRequest, options?: CashRequestOptions) => post<GetRestrictionSnapshotsRequest, GetRestrictionSnapshotsResponse>("/2.0/cash/get-restriction-snapshots", request, {...options, rejectOnError: true })